import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import * as AppStoreSelectors from 'apps/middle/src/app/root-store/app-store/selectors';
import * as AppStoreActions from 'apps/middle/src/app/root-store/app-store/actions';
import { getResolvedUrl } from '@aston/foundation';

@Injectable({
	providedIn: 'root'
})
export class RouteWithClearanceLevelsGuard implements CanActivate {
	private router = inject(Router);
	private store = inject(Store);


	canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
		if (!next.data.clearanceLevels || !next.data.clearanceLevels.length) {
			return of(true);
		}

		return this.store.pipe(
			select(AppStoreSelectors.selectClearsLevels(next.data.clearanceLevels)),
			map(allowed => {
				if (!allowed) {
					this.store.dispatch(AppStoreActions.ToastWarning('NotificationMessages.Warnings.PermissionDenied', { autoCloseDelay: 10000 }));

					if (next.data.redirectUrl) {
						// if the redirect url is also disallowed
						if (next.data.redirectUrl === getResolvedUrl(next)) {
							this.store.dispatch(AppStoreActions.NotFound({ message: 'Errors.NotFound' }))
						} else {
							this.router.navigate([next.data.redirectUrl]);
						}
					}
				}
				return !!allowed;
			}),
			first()
		);
	}
}
